import { useQuery } from "@tanstack/react-query";

import { useAppState } from "../../../../../../context/StateContext";
import DespatchProductService from "../../../../../../services/despatch.product.service";
import DespatchService from "../../../../../../services/despatch.service";
import { DespatchKeys } from "../../../../../../util/queries";

const CACHE_TIME = 60 * 60 * 1000; // 1 hour

const useAction = () => {
  const { currentUser } = useAppState();

  const getDespatchView = (despatchId: number) => {
    return useQuery({
      queryKey: DespatchKeys.getById(despatchId),
      queryFn: async () => {
        const response = await DespatchService.getById(despatchId, {
          include: JSON.stringify([
            { association: "originAddress" },
            { association: "destinationAddress" },
            { association: "shippingItems" },
            { association: "fleets" },
          ]),
        });

        return response.data;
      },
      enabled: !!currentUser?.id && !!despatchId,
      staleTime: 3 * 60 * 1000, // 2 minutes
      cacheTime: CACHE_TIME,
    });
  };

  const getProductsByDespatchView = (id: number) => {
    return useQuery({
      queryKey: DespatchKeys.getProducts(id),
      queryFn: async () => {
        const response = await DespatchProductService.getAll({
          despatchId: id,
          include: JSON.stringify([
            {
              association: "container",
              include: [{ association: "product" }],
            },
          ]),
        });

        if (response && response.data) return response.data;
      },
      enabled: !!currentUser?.id && !!id,
      staleTime: 3 * 60 * 1000, // 2 minutes
      cacheTime: CACHE_TIME,
    });
  };

  return {
    getDespatchView,
    getProductsByDespatchView,
  };
};

export default useAction;
